import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
import { Subscription } from 'rxjs'; 

@Component({
  selector: 'app-dcrunlockapproval',
  template: require('./dcrunlockapproval.component.html'),
  styles: []
})
export class DcrUnlockApprovalComponent implements OnInit {

  api: GridApi;
  columnApi: ColumnApi;
  expDetails: any;
  private columnDefs;
  private rowData: any[];
  private rowHeight;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;
  busy: Subscription;
  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;
  EmployeeId: any = [];
  token:any;
  static parameters = [ApiService]
  rowSelectionMultiple: string;

  constructor(
    private apiService: ApiService

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      { headerName: '', field: 'action', width: 150, checkboxSelection: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true },
      {
        headerName: 'Employee Name', field: "Client_Name", filter: 'agTextColumnFilter'
      },
      { headerName: 'Designation', field: "Designation", filter: 'agTextColumnFilter' },
      { headerName: 'Head Qtr', field: "HQName", filter: 'agTextColumnFilter' },
      { headerName: 'Day Plan Time', field: "PlanTime", filter: 'agTextColumnFilter' },
      { headerName: 'DCR Date', field: "PlanDate", filter: 'agTextColumnFilter' },
    ];
    this.defaultColDefine = { resizable: true };
    this.rowHeight = 50;
  }


  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.rowSelectionMultiple = 'multiple';
    this.rowData = [];
    this.GetDCRUnlockListForApproval();
  }

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();
  }
  
  onBtnExport() {
    this.api.exportDataAsCsv({ fileName: 'DCRLockList' });
  }
  
  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }
  
  approve() {
    this.EmployeeId = [];
    this.EmployeeId = this.api.getSelectedRows();
    if (this.EmployeeId.length == 0) {
      alert(`Please Select DCR For Approval`);
      return false;
    }
    var DayPlanId = this.EmployeeId.map(item => item.DayPlanId).toString();
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    console.log('token', token);
    var data = { data: DayPlanId, Id: token.clientId };
    this.busy = this.apiService.DCRUnlockApproval(data).subscribe((res: any) => {
      alert("DCR Unlock Successfully");
      this.GetDCRUnlockListForApproval();
    })
  }

  GetDCRUnlockListForApproval(){
    var queryData = {
      LoginId: this.token.id,
      
    }
    this.busy = this.apiService.GetDCRUnlockListForApproval(queryData).subscribe((res: any) => {
      this.rowData = res;
      console.log('this.rowData', this.rowData);
     // this.getChemistForReset();
    })
  }

}
